/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    INVENTORY_PAGE_SPLIT_COMPONENTS_DELETE_MODAL
 * Date:         2025-12-30
 * Modified By:  Cursor
 *
 * Description:
 * Extracted Delete confirmation modal from InventoryPage.tsx.
 */

import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Inventory } from "../../../../interfaces/Inventory";

interface InventoryDeleteModalProps {
  deleteConfirmItem: Inventory | null;
  onHide: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

const InventoryDeleteModal: React.FC<InventoryDeleteModalProps> = ({
  deleteConfirmItem,
  onHide,
  onConfirm,
  isDeleting,
}) => {
  return (
    <Modal show={!!deleteConfirmItem} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">
          Are you sure you want to delete "{deleteConfirmItem?.title || "this item"}"? This action
          cannot be undone.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide} disabled={isDeleting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Deleting...
            </>
          ) : (
            "Delete"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InventoryDeleteModal;
